import { render, staticRenderFns } from "./DementiaKnowledgeActivity.vue?vue&type=template&id=e4df65da&lang=true&"
import script from "./DementiaKnowledgeActivity.vue?vue&type=script&lang=js&"
export * from "./DementiaKnowledgeActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
